<template>
  <v-chart :options="pie" theme="ovilia-green" />
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 40vh !important;
}
</style>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar'

import theme from './theme.json'
ECharts.registerTheme('ovilia-green', theme)

export default {
  components: {
    'v-chart': ECharts,
  },
  props: {
    chartData: {
      type: Array,
      default: () => {
        return []
      },
    },
    chartTitle: {
      type: String,
      required: true,
    },
    chartSubTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pie: {
        title: {
          text: this.chartTitle,
          subtext: this.chartSubTitle,
          left: 'center',
          textStyle: {
            fontFamily: 'Montserrat',
            fontWeight: 700,
            fontSize: 16,
          },
          subtextStyle: {
            fontFamily: 'Montserrat',
            fontWeight: 500,
          },

          itemGap: 5,
          padding: [
            -1, // up
            10, // right
            25, // down
            10, // left
          ],
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          top: '12%',
          orient: 'vertical',
          left: 'left',
          data: this.chartData.map((data) => data.name),
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: {
              show: true,
              type: ['pie', 'funnel'],
            },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            name: 'Total Checked Passengers',
            type: 'pie',
            top: '5%',

            radius: [30, 110],
            // center: ['75%', '50%'],
            roseType: 'area',
            data: this.chartData,
          },
        ],
      },
    }
  },
  watch: {
    chartData(d) {
      this.pie.series[0].data = d
    },
    chartTitle(t) {
      this.pie.title.text = t
    },
  },
}
</script>
